import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, FileTextIcon } from 'lucide-react';
export type ViewMode = 'interactive' | 'cv';
interface ViewToggleProps {
  view: ViewMode;
  onChange: (v: ViewMode) => void;
  /** Visual theme: light for the CV surface, dark for the portfolio. */
  theme?: 'light' | 'dark';
}
const OPTIONS = [{
  id: 'interactive' as const,
  label: 'Interactive',
  Icon: SparklesIcon
}, {
  id: 'cv' as const,
  label: 'CV',
  Icon: FileTextIcon
}];
/**
 * Segmented control that switches the view in place (no route change). The
 * active pill slides between options with a shared layout animation.
 */
export function ViewToggle({
  view,
  onChange,
  theme = 'light'
}: ViewToggleProps) {
  const track = theme === 'dark' ? 'border-white/12 bg-white/[0.05]' : 'border-[var(--line-strong)] bg-white/70';
  const idle = theme === 'dark' ? 'text-stone-400 hover:text-white' : 'text-[var(--ink-soft)] hover:text-[var(--ink)]';
  return <div role="tablist" aria-label="View mode" className={`inline-flex items-center gap-0.5 rounded-full border p-0.5 backdrop-blur ${track}`} data-id="element-307" data-mp="1squlgq2jya3z">
      {OPTIONS.map(({
      id,
      label,
      Icon
    }) => {
      const active = view === id;
      return <button key={id} type="button" role="tab" aria-selected={active} onClick={() => onChange(id)} className={`relative inline-flex items-center gap-1.5 rounded-full px-3.5 py-1.5 font-mono text-[11px] uppercase tracking-[0.14em] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)] focus-visible:ring-offset-1 ${active ? 'text-white' : idle}`} data-id="element-308" data-mp="1e3t1gg72d5bo">
            {active && <motion.span layoutId="viewTogglePill" aria-hidden="true" className="absolute inset-0 rounded-full bg-[var(--accent)]" transition={{
          type: 'spring',
          stiffness: 400,
          damping: 32
        }} data-id="element-309" data-mp="2ui1811bfv41o" />}
            <Icon className="relative z-10 h-3.5 w-3.5" aria-hidden="true" data-id="element-310" data-mp="sm24cp8nju4p" />
            <span className="relative z-10" data-id="element-311" data-mp="dwnxpowgnqt0">{label}</span>
          </button>;
    })}
    </div>;
}